export const NotificationConstants = {
  UPDATE_NOTIFICATION: "UPDATE_NOTIFICATION",
};
